import React from "react";
import {
  ArrowRight,
  Code2,
  Shield,
  Database,
  Globe,
  Cpu,
  Cog,
  Zap,
  Laptop,
  Network,
} from "lucide-react";
import { Link } from "react-router-dom";

function InternshipSection() {
  const branches = [
    { name: "Full Stack Web Development", icon: Globe },
    { name: "Frontend Development (React / UI)", icon: Globe },
    { name: "Backend Development (Node / API)", icon: Cpu },
    { name: "AI & Machine Learning", icon: Cpu },
    { name: "Data Science & Analytics", icon: Database },
    { name: "Cyber Security / Ethical Hacking", icon: Shield },
    { name: "Cloud & DevOps", icon: Network },
    { name: "Mobile App Development", icon: Laptop },
    { name: "UI/UX Design", icon: Globe },
    { name: "Software Testing / QA", icon: Cog },
  ];

  return (
    <section className="relative py-16 px-6 lg:px-16 overflow-hidden bg-[#f8f8f8] dark:bg-[#050505] transition-all duration-300">
      {/* GLOW EFFECTS */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px]bg-primary/10 blur-[140px] rounded-full"></div>
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-primary/10 blur-[140px] rounded-full"></div>

      {/* GRID BACKGROUND */}
      <div
        className="absolute inset-0 
      bg-[linear-gradient(rgba(0,0,0,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.03)_1px,transparent_1px)] 
      dark:bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] 
      bg-[size:70px_70px]"
      ></div>

      {/* CONTENT */}
      <div className="relative max-w-7xl mx-auto">
        {/* TAG */}
        <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-primary/20 bg-primary/10 text-primary text-xs md:text-sm font-semibold">
          Web X Secure Program
        </span>

        {/* TITLE */}
        <h1 className="mt-6 text-3xl md:text-6xl font-black leading-tight text-black dark:text-white">
          Top Internship Domains{" "}
          <span className="block text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-yellow-400">
            for Students
          </span>
        </h1>

        {/* DESCRIPTION */}
        <p className="myparagraph max-w-3xl text-gray-600 dark:text-white/70">
          Explore high-demand internship fields for BTech & Diploma students in
          modern tech industries.
        </p>

        {/* BRANCHES */}
        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {branches.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={index}
                className="flex items-center gap-2 p-3 rounded-lg border transition-all
                bg-white text-black border-gray-200 hover:bg-gray-100
                dark:bg-white/5 dark:text-white dark:border-white/10 dark:hover:bg-white/10"
              >
                <Icon className="w-4 h-4text-primary" />
                <span className="text-sm">{item.name}</span>
              </div>
            );
          })}
        </div>

        {/* BUTTON */}
        <div className="mt-10">
          <Link
            to="https://webxsecure.in/contact"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition-all
            bg-primary text-white hover:bg-primary
            dark:shadow-[0_0_30px_rgba(255,120,50,0.4)]"
          >
            Apply Now
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </div>
    </section>
  );
}

export default InternshipSection;
